// PackageDetails.jsx
import { useState, useEffect, useRef } from "react";
import { Box, CircularProgress, Divider } from "@mui/material";
import FieldsTable from "@/Components/Tables/FieldsTable";
import { SectionHeader } from "@/Components/Header/SectionsHeader";
import { LuX } from "@/Components/Icons/Icons";
import { OutLinedButton } from "@/Components/Buttons/OutLinedButton";
import { BlackButton } from "@/Components/Buttons/FiledButton";
import {
  useCreatePackageDetailsMutation,
  useUpdatePackageDetailsMutation,
  useDeletePackageDetailsMutation,
  useGetPackageDetailsByMasterIdQuery,
} from "@/redux/ExportPage/CreateNewJob/Container/ContainerPackageSlice";
// import { useGetQuantityQuery } from "@/redux/ExportPage/CreateNewJob/Shipment/ShipmentMainSlice";
import SuccessDialog from "@/Components/Dialog/SuccessDialog";
import { BiSolidError } from "react-icons/bi";
import { LuCheck } from "@/Components/Icons/Icons";
import { useUser } from "@/Context/UserContext";
import TableGenerator from "@/Utils/FormGenerator/TableGenerator";
import FormDialog from "@/Components/Dialog/FormDialog";
import HighSeaSellerSchema from "@/Config/ImportJob/CreateNewJob/General/HighSeaSellerSchema";
import { useCreateHighSeaSellerMutation } from "@/redux/ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
import { importHookMap } from "@/redux/importHookMap";
import { useGetHighSeaSellerQuery } from "@/redux/ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
import {
  useUpdateHighSeaSellerMutation,
  useDeleteHighSeaSellerMutation,
} from "@/redux/ImportPage/CreateNewJob/General/HighSeaSellerApiSlice";
import InputTextField from "@/Components/Form/InputTextField";
import DateSelector from "@/Components/Form/DateSelector";
import InputDropdown from "@/Components/Form/InputDropdown";
import { hookMap } from "@/redux/hookMap";
import { useParams } from "react-router";
import InvoiceQuicikEntrySchema from "@/Config/Export/CreateNewJob/Invoice/InvoiceQuicikEntrySchema";
import MultiSelectDropdown from "@/Components/Form/MultiSelectDropdown";
import { useGlobalFilter } from "@/Context/GlobalFilterContext";
import dayjs from "dayjs";
import DateRangeSelector from "@/Components/Form/DateRangeCalendar";
import { useApplyimportDashboardFilterMutation } from "@/redux/ImportPage/Dashboard/DashboardfilterSlice";
import { useGetExportJobsQuery } from "@/redux/ExportPage/Dashboard/DashboardSlice";
import { useLazyGetInvoiceByMasterIdQuery } from "@/redux/ExportPage/CreateNewJob/Invoice/InvoiceMainSlice";
import { useLazyGetProductInvoiceMainIdQuery } from "@/redux/ExportPage/CreateNewJob/Product/Main/ProductMainSlice";
import { useLazyGetExportJobsQuery } from "@/redux/ExportPage/Dashboard/DashboardSlice";

export default function ProductReImportInit({ onClose }) {
  const [rows, setRows] = useState([]);

  // const { data: quantityOptions = [] } = useGetQuantityQuery();
  const [loading, setLoading] = useState(false);
  const { exporterMasterId, formData, setFormData, setValueGlobal } = useUser();
  const [currentPage, setCurrentPage] = useState(1); // 1-based
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [invoice, setInvoice] = useState(null);
  const [exportJob, setExportJob] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState([]);
  const [workingPeriod, setWorkingPeriod] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const { financialYear, city } = useGlobalFilter();
  const [currentStep, setCurrentStep] = useState("job");
  const [taskValue, setTaskValue] = useState("");
  const [taskType, setTaskType] = useState(null);
  const [applyDashboardFilter] = useApplyimportDashboardFilterMutation();
  const [dateRange, setDateRange] = useState([null, null]);

  const [
    fetchInvoiceById,
    { data: invoiceData, isLoading: invoiceLoading, error: invoiceError },
  ] = useLazyGetInvoiceByMasterIdQuery();
  const [
    fetchImportproductMain,
    { data: productData, isLoading: productLoading },
  ] = useLazyGetProductInvoiceMainIdQuery();
  // const { data, isLoading, isFetching, refetch } = useGetimportDashboardQuery();
  const {
    data: SBDetails,
    isLoading,
    refetch,
    error,
    isFetching,
  } = useGetExportJobsQuery({
    financialYear,
    cityId: city?.id || "",
    // organizationId: user?.organizationId || "",
  });

const [
  triggerGetExportJobs,
  {
    data: FilterSBDetails,
    isLoading:filerLoading,
    error : filerError,
    isFetching : filerIsFetching,
  },
] = useLazyGetExportJobsQuery();

  useEffect(() => {
    if (error) {
      // ✅ clear data on error response (like 400)
      setFormData((prev) => ({
        ...prev,
        SBDetails: [],
      }));
      return;
    }

    if (!isFetching && Array.isArray(SBDetails)) {
      const dataWithSrNo = SBDetails?.map((item, index) => ({
        ...item,
        srNo: index + 1,
        id: item?.exporterMasterId,
      }));

      setFormData((prev) => ({
        ...prev,
        SBDetails: dataWithSrNo,
      }));
    }
  }, [SBDetails, isFetching, error]);

  const handleGetInvoiceData = async () => {
    const invoices = await fetchInvoiceById({ id: exportJob?.id });
    console.log(invoices, "invoices", invoiceData, error);

    setFormData((prev) => ({
      ...prev,
      importInvoice: invoices?.data,
    }));
  };

  const handleInitialize = () => {
    if (!selectedProduct) {
      return;
    }
    console.log("Initializing from product:", selectedProduct,exportJob,invoice);

    const convertToISO = (dateTimeStr) => {
      if (!dateTimeStr) return null;

      const [datePart, timePart] = dateTimeStr.split(" ");
      const [dd, mm, yyyy] = datePart.split("-");

      // Construct ISO format: YYYY-MM-DDTHH:mm:ssZ
      return `${yyyy}-${mm}-${dd}`;
    };
    const beDateValue = convertToISO(exportJob?.sbDate);
    const assessbleValue = selectedProduct?.assessbleValue;
    const dutypaidTotal = selectedProduct?.dutypaidTotal;
    console.log(beDateValue, "beDateValue",new Date(beDateValue));
    // Example mapping — adjust according to your schema
    setValueGlobal("importProductReImportSBNO", exportJob?.sbNumber);
    setValueGlobal("importProductReImportSBDate",  beDateValue ? dayjs(beDateValue) : null);
    setValueGlobal(
      "importProductReImportSBInvsno",
      invoice?.srNo || null
    );

   
    setValueGlobal(
      "importProductReImportSBitemsno",
      String(selectedProduct?.srNo || null)
    );



    onClose();
  };

  const handleGetProductData = async () => {
    const product = await fetchImportproductMain({ id: invoice?.id });
    console.log(product, "invoices");

    setFormData((prev) => ({
      ...prev,
      importProduct: product?.data,
    }));
  };

  const formRef = useRef();

  const branchList = [
    { label: "Ahmedabad", value: "Ahmedabad" },
    { label: "Bangalore", value: "Bangalore" },
    { label: "Chennai", value: "Chennai" },
    { label: "Hyderabad", value: "Hyderabad" },
    { label: "Kolkata", value: "Kolkata" },
    { label: "Mumbai", value: "Mumbai" },
    { label: "New Delhi", value: "New Delhi" },
    { label: "Tuticorin", value: "Tuticorin" },
  ];

  const taskTypeOptions = [
    { label: "Job No", value: "jobNo" },
    { label: "S/B No", value: "sbno" },
    { label: "AWB/BL No", value: "awbblno" },
    { label: "BE No", value: "beNo" },
    { label: "Invoice No", value: "invoiceNo" },
  ];

  const TOIData = [
    { label: "FOI", value: "FOI" },
    { label: "CIF", value: "CIF" },
    { label: "C&F", value: "C&F" },
    { label: "C&I", value: "C&I" },
  ];

  const handleActions = () => {};

  const handlers = {
    handleRowClick: (row) => {
      if (!row) return;
      if (currentStep === "job") {
        setExportJob(row);
      } else if (currentStep === "invoice") {
        setInvoice(row);
      } else if (currentStep === "product") {
        setSelectedProduct(row);
      }
    },
  };

  const visibleFieilds =
    currentStep === "job"
      ? [
          { key: "srNo", label: "Branch", width: "70px" },
          { key: "jobNumber", label: "Job No", width: "120px" },
          { key: "jobDate", label: "Job Date", width: "120px" },
          { key: "sbNumber", label: "SB No", width: "180px" },
          { key: "sbDate", label: "SB Date", width: "180px" },
        ]
      : currentStep === "invoice"
        ? [
            { key: "srNo", label: "Sr.No", width: "70px" },
            { key: "exportInvoiceNumber", label: "Invoice No", width: "120px" },
            { key: "exportInvoiceDate", label: "Invoice Date", width: "120px" },
            { key: "currencyValue", label: "Total Value", width: "180px" },
          ]
        : [
            { key: "srNo", label: "Sr.No", width: "70px" },
            {
              key: "exportProductMainDescriptionId",
              label: "Description",
              width: "120px",
            },
            {
              key: "exportProductMainRITCorHSNCodeId",
              label: "HSN Code",
              width: "120px",
            },
            { key: "exportProductMainAmount", label: "Amount", width: "180px" },
          ];

  const isStepLoading = () => {
    if (currentStep === "job") return isFetching;
    if (currentStep === "invoice") return invoiceLoading;
    if (currentStep === "product") return productLoading;
    return false;
  };

  const resetFilters = () => {
    setWorkingPeriod("");
    setSelectedBranch([]);
    setDateRange([null, null]);
    setTaskType("");
    setTaskValue("");
  };

  const handleSearch = async () => {
    const payload = {
      filter: {
        financialYear: workingPeriod || "",
        branchIds: selectedBranch?.map((b) => b.value) || [],
        dateRange:
          dateRange[0] && dateRange[1]
            ? {
                from: dayjs(dateRange[0]).format("YYYY-MM-DD"),
                to: dayjs(dateRange[1]).format("YYYY-MM-DD"),
              }
            : undefined,
        ...(taskType && taskValue ? { [taskType]: taskValue } : {}),
      },
    };


    try {
      const result = await triggerGetExportJobs(payload).unwrap();
      console.log("✔ Filter Applied", result);

      const response = result?.map((item, index) => ({
        ...item,  
        srNo: index + 1,
        id: item?.exporterMasterId,
      }));

      setFormData((prev) => ({
        ...prev,
        SBDetails: response,
      }));
      resetFilters();
    } catch (error) {
      console.error("❌ Filter Error:", error);
      setFormData((prev) => ({
        ...prev,
        SBDetails: [],
      }));
    }
  };

  const generateWorkingPeriods = () => {
    const periods = [];
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0 = Jan, 2 = Mar, 3 = Apr

    // Determine the current financial year start
    let fyStartYear;

    if (currentMonth < 3) {
      // Jan, Feb, Mar → still in previous FY
      fyStartYear = currentYear - 1;
    } else {
      // Apr or later → new FY started
      fyStartYear = currentYear;
    }

    const START_YEAR = 2015;

    for (let start = fyStartYear; start >= START_YEAR; start--) {
      const end = start + 1;
      periods.push({
        label: `${start}-${end}`,
        value: `${start}-${end}`,
      });
    }

    return periods;
  };

  const workingPeriodOptions = generateWorkingPeriods();

  const handleFilterChange = (e) => {
    console.log(e, "e check");
    setWorkingPeriod(e);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "var(--gray-0)",
        width: "100%",
        maxWidth: "100vw",
        height: 700,
        // maxHeight: 600,
        mb: 2,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 2,
          m: 0.5,
        }}
      >
        <SectionHeader title={"BE Details"} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            gap: 4,
            alignItems: "center",
            // pr: 2,
            // m: 1,
          }}
        >
          <LuX size={20} style={{ cursor: "pointer" }} onClick={onClose} />
        </Box>
      </Box>
      <Divider />

      {/* Add Button */}

      {/* Table */}
      <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
        {/* Prefill Section - NEW */}
        {currentStep === "job" && (
          <>
            <Box
              sx={{
                border: "1px solid var(--gray-400)",
                borderRadius: 2,
                p: 2,
                m: 2,
                backgroundColor: "var(--gray-50)",
                display: "flex",
                flexDirection: "column",
                gap: 3,
              }}
            >
              {/* 🔵 Row 1 – Working Period + Date Range + Search */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr auto",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                {/* Working Period */}
                <InputDropdown
                  label="Working Period"
                  placeholder="Choose year"
                  options={workingPeriodOptions}
                  onChange={handleFilterChange}
                  value={workingPeriod}
                />

                {/* Date Range */}
                <DateRangeSelector
                  label="Date Range"
                  value={dateRange}
                  onChange={setDateRange}
                  width="100%"
                  sx={{ mt: 4 }}
                />

                {/* Search Button */}
                <OutLinedButton
                  variant="contained"
                  color="secondary"
                  label="Search"
                  sx={{ width: "120px", mt: 4 }}
                  onClick={handleSearch}
                />
              </Box>

              {/* 🔵 Row 2 – Branch + Task Type + Task Value */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                {/* Branch Multi-select */}
                <MultiSelectDropdown
                  label="Branch"
                  value={selectedBranch}
                  onChange={setSelectedBranch}
                  placeholder="Select Branch Name"
                  options={branchList}
                  width="100%"
                  sx={{ minWidth: 220 }}
                />

                {/* Task Type Dropdown – autofills text field */}
                <InputDropdown
                  label="Task Type"
                  placeholder="Select Task"
                  options={taskTypeOptions}
                  value={taskType}
                  onChange={(value) => {
                    setTaskType(value);
                    if (!value) setTaskValue(""); // clear when unselected
                  }}
                />

                <InputTextField
                  label="Task Value"
                  value={taskValue}
                  onChange={(e) => setTaskValue(e.target.value)}
                  disabled={!taskType} // 🔥 TextField enabled only when dropdown selected
                />
              </Box>
            </Box>
          </>
        )}

        {/* Loader + Table */}
        {isStepLoading() && (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
              width: "100%",
              gap: 1,
            }}
          >
            <CircularProgress size={40} sx={{ color: "var(--brand-600)" }} />
          </Box>
        )}

        {!isStepLoading() && (
          <TableGenerator
            compKey={
              currentStep === "job"
                ? "SBDetails"
                : currentStep === "invoice"

                  ? "importInvoice"
                  : "importProduct"
            }
            visibleFields={visibleFieilds}
            label={
              currentStep === "job"
                ? "SBDetails"
                : currentStep === "invoice"
                  ? "importInvoice"
                  : "importProduct"
            }
            handlers={handlers}
            showActions={false}
          />
        )}
      </Box>

      {/* Footer */}
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          justifyContent: "flex-end",
          borderTop: "1px solid var(--gray-400)",
        }}
      >
        <OutLinedButton
          variant="contained"
          color="secondary"
          onClick={onClose}
          label="Cancel"
          sx={{ width: 100, mt: 3 }}
        />
        <BlackButton
          variant="contained"
          color="secondary"
          onClick={handleSave}
          label={loading ? "Saving..." : "Save"}
          disabled={loading || isSaveDisabled}
          sx={{ mr: 5, width: 100, mt: 3 }}
        />
      </Box> */}

      {/* <SuccessDialog
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        {...successDialogConfig}
      />
      {showForm && (
        <FormDialog
          title={isEditing ? `Edit Quick Entry` : `Add Quick Entry`}
          schema={InvoiceQuicikEntrySchema}
          initialData={formDialogData}
          isEditing={isEditing}
          onSubmit={() => handleSave("table")}
          handleActions={handleActions}
          onClose={handleCloseForm}
          showCancelButton={true}
          showSubmitButton={true}
          cancelLabel="Cancel"
          submitLabel={isEditing ? "Save" : "Add"}
          loading={loading}
          ref={formRef}
          // disabled={!isRequiredFieldFilled}
        />
      )} */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mx: 2,
          borderTop: "1px solid var(--gray-400)",
          mt: 2,
          gap: 2,
        }}
      >
        {currentStep === "job" && (
          <>
            <BlackButton
              label="Proceed > > > "
              onClick={() => {
                handleGetInvoiceData();
                setCurrentStep("invoice");
              }}
              sx={{
                mt: 2,
                width: "200px",
              }}
              disabled={!exportJob} // Only enable when job is selected
            />
          </>
        )}

        {currentStep === "invoice" && (
          <>
            <OutLinedButton
              label="< < < Back to Job"
              onClick={() => setCurrentStep("job")}
              sx={{
                mt: 2,
                width: "200px",
              }}
            />

            <BlackButton
              label="Proceed > > >"
              onClick={() => {
                handleGetProductData();
                setCurrentStep("product");
              }}
              sx={{
                mt: 2,
                width: "200px",
              }}
              disabled={!invoice}
            />
          </>
        )}

        {currentStep === "product" && (
          <>
            <OutLinedButton
              label="< < < Back to Invoice"
              onClick={() => setCurrentStep("invoice")}
              sx={{
                mt: 2,
                width: "200px",
              }}
            />

            <BlackButton
              label="Initialize From Product"
              sx={{
                mt: 2,
                width: "200px",
              }}
              onClick={handleInitialize}
              disabled={selectedProduct?.length === 0}
            />
          </>
        )}
      </Box>
    </Box>
  );
}
